import { Component, OnInit } from '@angular/core';
import { DconConfigAPI } from 'src/app/features/dfte-grid-view/config/config';
import { DataService } from 'src/app/features/dfte-grid-view/config/data.service';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {
  showLegacy: boolean = false;
  showConfigBuild:boolean=DconConfigAPI.USE_CONFIGBUILD_FEATURE
  constructor(private _data:DataService) { }

  ngOnInit(): void {
    this.showLegacy = JSON.parse(sessionStorage.getItem("LegacyStatus").toLowerCase());
  }

  maskPage(){
    // this._data.apiCallInProgress = true;
    // document.getElementById("overlay").style.display = "block";
  }


}
